// Import React Libraries
import React, { useEffect, useState } from "react";
import classNames from "classnames/bind";
import { ScrollDetail } from "@ionic/core/components";

// Import Ionic Components
import { IonButton, IonIcon } from "@ionic/react";
// Import Styles
import "./Home3.scss";
import styles from "./Home3.module.scss";

// import components
import Banner from "../../components/Banner/Banner";
import MaxWidthContainer from "../../components/UI/MaxWidthContainer/MaxWidthContainer";
import AboutCompanySEO from "../../components/SEO/AboutCompanySEO";
import HomePageCategories from "../../components/HomPageCategories/HomePageCategories";
import HomePageSearchBox from "../../components/HomePageSearchBox/HomePageSearchBox";
import HomeProductsWidget from "../../widgets/HomeProductsWidget/HomeProductsWidget";
import useWindowSize from "../../utils/useWindowSize";
import Page from "../page-layout";
import { useConfig } from "../../providers/config";
import { heart } from "ionicons/icons";
import { CustomerAddressSelectProvider } from "../../providers/CustomerAddresses/CustomerAddressesStateContext";
import { CurrentShippingAddress } from "../../components/CurrentShippingAddress/CurrentShippingAddress";
import { StoriesBar } from "../../components/StoriesBar/StoriesBar";
import { useBackButton } from "../../hooks/useBackButton";
import ToggleActiveModule from "../../components/ToggleActiveModule";
import { useTranslation } from "react-i18next";
import { useForceToGoNewVersion } from "../../hooks";

const cx = classNames.bind(styles);

const RELATIVE_INPUT_THRESHOLD = 100;

// Parent Component
const Home3: React.FC = () => {
  const { width, md } = useWindowSize();
  const { t } = useTranslation();
  const [showSearch, setShowSearch] = useState(false);
  const config = useConfig();

  useBackButton();
  useForceToGoNewVersion();
  
  function handleScroll(event: CustomEvent<ScrollDetail>) {
    if (event.detail.scrollTop !== 0 && event.detail.scrollTop > RELATIVE_INPUT_THRESHOLD) {
      setShowSearch(true);
    } else {
      setShowSearch(false);
    }
  }

  return (
    <Page>
      <Page.Header className={cx("header")} />

      <Page.HeaderMobile showSearchButton={showSearch} />

      <Page.Content className={cx("ion-padding-bottom")} scrollEvents onIonScroll={handleScroll}>
        <Page.HeaderDesktop showShippingCurrentAddress={config.shipping.showCurrentShippingAddressSelect} />
        <div className={"global-content"}>
          <MaxWidthContainer>
            {/* <Categories  /> */}
            {width <= md && (
              <div className={cx("container", "ion-hide-md-up")}>
                {config.isToggleSwitchModuleEnabled && <ToggleActiveModule isViewDescription={true} />}

                {!config?.isExpressDeliveryEnabled && config?.shipping.showCurrentShippingAddressSelect && (
                  <CustomerAddressSelectProvider>
                    <div className={cx("currentAddress__margins")}>
                      <CurrentShippingAddress />
                    </div>
                  </CustomerAddressSelectProvider>
                )}
                {width > md && <HomePageSearchBox placeholder={t("Search in the store")} />}
              </div>
            )}
            {config?.isStoriesEnabled && <StoriesBar />}
            {width < md && (
              <div className="flex justify-center items-center gap-2 mx-2.5 md:hidden">
                <HomePageSearchBox wrapperStyles="flex-1 !max-w-full" placeholder={t("Search in the store")} />
                <IonButton fill="clear" routerLink="/wish-list" routerDirection="forward" className={cx("button")}>
                  <IonIcon className={cx("icon")} icon={heart} />
                </IonButton>
              </div>
            )}
            {!config?.wishListIcons ? (
              <>
                <HomePageCategories />
                <Banner />
              </>
            ) : (
              <>
                <Banner />
                <HomePageCategories />
              </>
            )}
            <div style={{ overflow: "hidden" }}>
              <HomeProductsWidget />
            </div>
          </MaxWidthContainer>
          {config?.isSeoOnHomePageEnabled && (
            <MaxWidthContainer>
              <AboutCompanySEO />
            </MaxWidthContainer>
          )}
        </div>
        <Page.ContentFooter />
      </Page.Content>
    </Page>
  );
};

export default Home3;
